import type { Component } from 'vue'
import type { RunOptions, TransitionOut } from '@/features/domaine/machine-etats/types.ts'
import { useMachineEtatDisplay } from '@/features/interface/machine-etats/useMachineEtat.ts'

export function fabriqueRunCarte<TIn = void, TOut = void>(component: Component) {
  return async (options: RunOptions<TIn>) => {
    const display = useMachineEtatDisplay()
    const result = await display.runComponent({ component, ...options })

    return {
      out: result.value,
      transitionState: result.transitionState,
      type: 'interactif',
    } as TransitionOut<TOut>
  }
}

export function fusionneEtats<T extends object>(etats: Record<string, T>) {
  return Object.values(etats).reduce((result, etat) => {
    return { ...result, ...etat }
  })
}
